var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 20,
    viewBox: "0 0 42 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-177.782%",
    y1: "47.343%",
    x2: "180.919%",
    y2: "51.513%",
    id: "n4ys3qwyoa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09063D",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054D6E",
    offset: "15.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028695",
    offset: "29.55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AAAE",
    offset: "39.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7B7",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA5B1",
    offset: "53.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D77A2",
    offset: "72.37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94390",
    offset: "91.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.149%",
    y1: "49.63%",
    x2: "108.221%",
    y2: "50.442%",
    id: "eh6bkffxyb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09063D",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054D6E",
    offset: "15.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028695",
    offset: "29.55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AAAE",
    offset: "39.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7B7",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA5B1",
    offset: "53.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D77A2",
    offset: "72.37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94390",
    offset: "91.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.407%",
    y1: "49.841%",
    x2: "102.992%",
    y2: "50.163%",
    id: "uowyi6vpic"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09063D",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054D6E",
    offset: "15.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028695",
    offset: "29.55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AAAE",
    offset: "39.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7B7",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA5B1",
    offset: "54.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D77A2",
    offset: "74.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94390",
    offset: "95.8%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.858 14.97a4.975 4.975 0 0 1-4.901-4.12l-3.89 3.91a9.997 9.997 0 0 0 8.791 5.233 9.99 9.99 0 0 0 3.404-.594l-3.23-4.437c-.06.002-.116.009-.174.009z",
    fill: "url(#n4ys3qwyoa)",
    transform: "translate(.928 .004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.854 9.96C40.834 4.457 36.366 0 30.858 0c-2.416 0-4.814.928-6.643 2.532a71.968 71.968 0 0 0-3.58 3.36l-.2.201c-.348.35-1.763 1.8-2.952 3.172s-3.31 3.435-3.31 3.435c-1.381 1.29-2.711 2-4.32 2.018-2.748.03-4.828-1.975-4.828-4.722a4.973 4.973 0 0 1 4.973-4.974 4.98 4.98 0 0 1 4.74 3.463l5.698-5.202V.003H14.97V1.33A9.942 9.942 0 0 0 9.998.002C4.477.002 0 4.477 0 10c0 5.52 4.475 9.996 9.998 9.996 1.81 0 3.509-.485 4.973-1.326h.004v1.323h5.459l.006-6.399.309-.315c.49-.5.981-1 1.468-1.5L25.897 8c1.4-1.437 2.789-2.972 4.961-2.972 2 0 3.72 1.182 4.509 2.883l-4.994-.038v4.189h10.48V9.96z",
    fill: "url(#eh6bkffxyb)",
    transform: "translate(.928 .004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.852 14.718c1.105.003 2.435-.491 3.304-1.17 1.967-1.539 3.36-3.197 5.011-5.046a71.217 71.217 0 0 1 6.046-5.97C26.043.928 28.443 0 30.856 0c5.52 0 9.998 4.475 9.998 9.998 0 0-6.259-5.045-9.996-4.973-2.17.042-3.56 1.535-4.962 2.972a2934.013 2934.013 0 0 0-3.679 3.78c-1.66 1.708-3.35 3.395-4.975 5.139l.009-.043a9.962 9.962 0 0 1-7.253 3.123C4.477 19.996 0 15.52 0 9.998c0 0 6.013 4.711 9.852 4.72z",
    fill: "url(#uowyi6vpic)",
    transform: "translate(.928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAe);
export default __webpack_public_path__ + "static/media/logo-ae.f416532db68f57367b68851b8b8d68eb.svg";
export { ForwardRef as ReactComponent };